var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.confirmed || !_vm.user || _vm.state === 'migrationExtras')?_c('div',[_c('authentication')],1):_c('div',[_c('preferences')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }